import {
  DataGridListStyle,
  greyColor,
  warnColor,
  InputFilterStyle,
  TelephoneStyle,
  Note,
  BtnGroupWAStyle,
  DRxInputStyle,
  DRxSelectStyle,
  HtmlTooltip,
} from "../../Theme";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Box from "@mui/material/Box";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { YSButton } from "../../uikit/YSButton";
import DRxInput from "../../uikit/DRxInput";
import { Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { YSSelectSearch } from "../../uikit/YSSelectSearch";
import {
  AddPatientProfilePharmacyInfoById,
  AddToFavPharmacy,
  ClinicDetails,
  PharmacyPopulate,
  PharmacySearchAjaxCall,
  SearchPharmacy,
} from "../../Apis/AuthApiServices";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import NoRecords from "../../components/NoRecords";
import YSSnackBar from "../../uikit/YSSnackBar";
import { DRxSelect2 } from "../../uikit/DRxSelect2";
import ErrorOverlay from "../../components/ErrorOverlay";
import useFetch from "../../CustomHooks/useFetch";
import HelpIcon from "@mui/icons-material/Help";
import { DialogPopup } from "../../components/DialogPopup";
import ss1 from "../../images/screenshots/pharmacysearch/screenshot1.png";
import ss2 from "../../images/screenshots/pharmacysearch/screenshot2.png";
import ss3 from "../../images/screenshots/pharmacysearch/screenshot3.png";
import ss4 from "../../images/screenshots/pharmacysearch/screenshot4.png";
import { loadingPharmacyDropDown } from "../../Redux/Slice/PharmacyDropDownSlice";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import AddToFavPharmIcon from "../../images/icons/AddToFavPharmIcon";
import ErxSuccess from "../../images/icons/ErxSuccess.svg";
import ErxWarning from "../../images/icons/ErxWarning.svg";
import ErxError from "../../images/icons/ErxError.svg";

export default function PharmacyDataList(props: any) {
  const dispatch = useDispatch();
  const AllDropdownsState = useSelector((state: any) => {
    return { ...state.GlobalDropdownSlice.DropdownLists };
  }); //redux data
  const PrescriberDetailsState = useSelector((state: any) => {
    return { ...state?.PrescriberDetailsSlice?.AllPrescriberDetails };
  }); //redux data
  const { formData } = props;
  const phone2Ref = useRef<any>(null);
  const phone3Ref = useRef<any>(null);
  const [stateValue, setStateValue] = useState("");
  const [data, setData] = useState({
    Name: "",
    Type: "",
    City: "",
    Zip: "",
    State: "",
    StateName: "",
    TelephoneCode: "",
    Telephone1: "",
    Telephone2: "",
  });
  const [validation, setValidation] = useState(false);
  const [mandateValidation, setMandateValidation] = useState(false);
  const [AjaxData, setAjaxData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  // const [selectionData, setSelectionData] = useState("");
  const [searchData, setSearchData] = useState<any>([]);
  const [pharmacySearchHelpPopup, setPharmacySearchHelpPopup] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [addFavPharmacyState, setAddFavPharmacyState] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [addNewPharmacy, setAddNewPharmacy] = useState<any>({
    message: "",
    open: false,
    varient: "",
  });
  const [pharmacySearchStatus, setPharmacySearchStatus] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [rowCountState, setRowCountState] = useState(
    searchData?.pagination?.totalItems || 0
  );
  const Params = {
    doctorId: localStorage.getItem("doctorId"),
    pageNumber: 0,
    pagination: "none",
  };
  const patientState = useSelector((state: any) => {
    return { ...state?.PatientDetailsSlice };
  });
  const { data: clinicData }: any = useFetch(Params, ClinicDetails, []);
  let selectedState: any;
  if (PrescriberDetailsState?.defaultPharmacySearchStateMode === "1") {
    selectedState = AllDropdownsState?.statesOptions?.filter((each: any) => {
      if (each?.value === patientState?.AllPatientDetails?.state) {
        return each;
      }
    });
  } else {
    let selectedClinicData = clinicData[0]?.items?.filter(
      (item: any) =>
        item?.personAddressId === PrescriberDetailsState?.selectedAddress
    );
    if (selectedClinicData) {
      selectedState = AllDropdownsState?.statesOptions?.filter(
        (each: any) => each?.value === selectedClinicData[0]?.state
      );
    }
  }

  const handleShowPharmacySearchHelpPopupClick = () => {
    setPharmacySearchHelpPopup(true);
  };
  const handleHidePharmacySearchHelpPopupClick = () => {
    setPharmacySearchHelpPopup(false);
  };
  const getPharmacyPopulate = async (PharmacyCode: any) => {
    try {
      const bodyData = {
        ...formData,
        patientId: sessionStorage.getItem("patientId"),
        pharmacyCode: PharmacyCode,
      };
      const result = await PharmacyPopulate(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        props.setPharmacyPopulateId(result?.data?.response);
        props.handleHidePopupClick();
        dispatch(loadingPharmacyDropDown());
      } else {
        props.setPharmacyPopulateId([formData]);
      }
    } catch (error) {
      setAddFavPharmacyState((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const GetPharmacySearchAjaxCall = async (Data: any) => {
    try {
      const params = new URLSearchParams();
      params.append("pharmacyName", Data.pharmacyName);
      params.append("pharmacytype", "All");
      params.append("state", stateValue);
      params.append("pageNumber", `${0}`);

      const result = await PharmacySearchAjaxCall(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setAjaxData(result?.data?.response[0]?.items);
      } else {
        setAjaxData([]);
      }
    } catch (error) {
      setAjaxData([]);
    }
  };
  const AddToYourFavPharmacy = async (pharmacyId: any) => {
    try {
      setAddFavPharmacyState((prevState: any) => {
        return {
          ...prevState,
          message: "Adding......",
          variant: "warning",
          open: true,
        };
      });
      const params = new URLSearchParams();
      const doctorId: any = localStorage.getItem("doctorId");
      params.append("doctorId", doctorId);
      params.append("selectedPharmacyIds", pharmacyId);

      const result = await AddToFavPharmacy(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setAddFavPharmacyState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setTimeout(() => {
          props.handleHidePopupClick();
        }, 1000);
      } else {
        setAddFavPharmacyState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setAddFavPharmacyState((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const AddNewPharmacy = async (pharmacyId: any) => {
    try {
      setAddNewPharmacy((prevState: any) => {
        return {
          ...prevState,
          open: true,
          message: "Adding......",
          variant: "warning",
        };
      });
      const params = new URLSearchParams();
      const patientId: any = sessionStorage.getItem("patientId");
      params.append("selectedPharmacy", pharmacyId);
      params.append("patientId", patientId);
      const result = await AddPatientProfilePharmacyInfoById(params);

      if (result?.data?.digitalRxStatusCode === 200) {
        setAddNewPharmacy((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setTimeout(() => {
          props.handleHidePopupClick();
          props.getPharmacyInformation();
        }, 1000);
      } else {
        setAddNewPharmacy((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setAddNewPharmacy((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const getPharmacySearchDetails = async (nextPage: any, values: any) => {
    try {
      setIsLoading(true);
      const params = new URLSearchParams();
      params.append("pageNumber", nextPage);
      params.append("pharmacyName", values.Name);
      params.append("pharmacytype", values.Type === "0" ? "" : values.Type);
      params.append("city", values.City);
      params.append(
        "state",
        values.State !== "Select State" ? values.State : ""
      );
      params.append("phoneCode", values.TelephoneCode);
      params.append("phoneNumber1", values.Telephone1);
      params.append("phoneNumber2", values.Telephone2);
      params.append("zip", values.Zip);
      const result = await SearchPharmacy(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setSearchData(result?.data?.response[0]);
        setIsLoading(false);
      } else {
        setSearchData([]);
        setPharmacySearchStatus((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setIsLoading(false);
      }
    } catch {
      setSearchData([]);
      setPharmacySearchStatus((prevState: any) => {
        return {
          ...prevState,
          message: "Try again after some time!",
          variant: "error",
          open: true,
        };
      });
      setIsLoading(false);
      setIsError(true);
    }
  };
  const checkValidation = (value: any, formProps: any) => {
    formProps.setFieldValue("Type", value);
    if (value === "Retail" || value === "All") {
      setMandateValidation(true);
    } else {
      setMandateValidation(false);
    }
    if (value !== "Mail Order") {
      setValidation(true);
    } else {
      setValidation(false);
    }
  };
  // const validationSchemaPharmacy = yup.object().shape({
  //   StateName: yup.string().required("State is required."),
  // });
  // mandateValidation
  //   ? yup.object().shape({
  //       State: yup.string().required("State is required."),

  //       Name: yup.string().required("Pharmacy Name is Required Required"),
  //     })
  //   : yup.object().shape({
  //       Name: yup.string().required("Pharmacy Name is Required"),
  //     });
  const pharmacyColumns: GridColDef[] = [
    {
      field: "pharmacyName",
      headerName: "Pharmacy Name / Address",
      width: 200,
      cellClassName: "w50",
      headerClassName: "w50",
      renderCell: ({ row }) => (
        <Typography
          onClick={() =>
            props.pharmacyInfoState
              ? null
              : getPharmacyPopulate(row?.pharmacyCode)
          }
          color={props.pharmacyInfoState ? "" : "primary"}
          component="div"
        >
          <Grid
            container
            display={"flex"}
            justifyContent={"left"}
            alignItems={"center"}
            gap={1}
          >
            <Grid item>
              <Typography variant="body2">{row?.pharmacyName} </Typography>
            </Grid>
            {row?.ssEnabledFlag === false ? (
              <Grid item>
                <img src={ErxError} alt="erx-error" height={24} />
              </Grid>
            ) : row?.epcsEnabled ? (
              <Grid item>
                <img src={ErxSuccess} alt="erx-success" height={24} />
              </Grid>
            ) : (
              <Grid item>
                <img src={ErxWarning} alt="erx-warning" height={24} />
              </Grid>
            )}
          </Grid>
          <Typography color="black" variant="caption">
            <LocationOnIcon style={{ height: 12, width: 12 }} />
            {row.address}
          </Typography>
        </Typography>
      ),
    },
    {
      field: "city",
      headerName: "City",
      width: 70,
      cellClassName: "w13",
      headerClassName: "w13",
      renderCell: ({ row }) => (
        <Typography style={{ wordBreak: "break-word" }} variant={"body2"}>
          {row?.city}
        </Typography>
      ),
    },
    {
      field: "state",
      headerName: "State",
      width: 10,
      cellClassName: "w8",
      headerClassName: "w8",
    },
    {
      field: "zip",
      headerName: "Zip",
      width: 10,
      cellClassName: "w8",
      headerClassName: "w8",
    },
    {
      field: "phoneNumber",
      headerName: "Telephone",
      width: 12,
      cellClassName: "w12",
      headerClassName: "w12",
    },
    {
      field: "specialityType",
      headerName: "Type",
      width: 8,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => (
        <Tooltip
          title={
            row?.specialityType === "MO"
              ? "Mail Order"
              : row?.specialityType === "IH"
              ? "In House"
              : row?.specialityType === "RT"
              ? "Retail"
              : row?.specialityType === "24hr,IH"
              ? "24hr, In House"
              : row?.specialityType === "24hr,IH,LTC"
              ? "24hr, In House, Long Term Care"
              : row?.specialityType === "IH,LTC"
              ? "In House, Long Term Care"
              : row?.specialityType === "FO"
              ? "Fax Only"
              : row?.specialityType
          }
        >
          <Typography style={{ wordBreak: "break-word" }} variant={"body2"}>
            {row?.specialityType}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 8,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => (
        <Tooltip
          title={
            props.pharmacyInfoState
              ? "Add To New Pharmacy"
              : "Add To Favorite Pharmacy"
          }
        >
          <IconButton
            color="primary"
            onClick={() => {
              props.pharmacyInfoState
                ? AddNewPharmacy(row?.pharmacyId)
                : AddToYourFavPharmacy(row?.pharmacyId);
            }}
          >
            {props.pharmacyInfoState ? (
              <AddCircleIcon />
            ) : (
              <AddToFavPharmIcon fontSize="medium" />
            )}
          </IconButton>
        </Tooltip>
      ),
    },
  ];
  useEffect(() => {
    setStateValue(selectedState ? selectedState[0]?.value : "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedState && selectedState[0]?.value]);
  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      searchData?.pagination?.totalItems !== undefined
        ? searchData?.pagination?.totalItems
        : prevRowCountState
    );
  }, [searchData?.pagination?.totalItems, setRowCountState]);

  return (
    <>
      <Formik
        initialValues={{
          Name: "",
          Type: "0",
          City: "",
          Zip: "",
          State: selectedState ? selectedState[0]?.value : "Select State",
          StateName: selectedState ? selectedState[0]?.label : "Select State",
          TelephoneCode: "",
          Telephone1: "",
          Telephone2: "",
        }}
        enableReinitialize
        onSubmit={(values) => {
          setData(values);
          getPharmacySearchDetails(page, values);
        }}
        // validationSchema={validationSchemaPharmacy}
      >
        {(formProps) => (
          <Form onSubmit={formProps.handleSubmit}>
            <Note style={{ marginBottom: 2 }}>
              <Typography variant="body2" component="div" fontWeight={600}>
                {`NEW PHARMACY SEARCH SCREEN: PLEASE CLICK ON THE LINKS FOR HELP =>`}
                <Typography component="span" color="primary" variant="body2">
                  <Box
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 5,
                      cursor: "pointer",
                      position: "relative",
                      fontWeight: 600,
                    }}
                    onClick={() => {
                      setPharmacySearchHelpPopup(true);
                    }}
                  >
                    DETAILED HELP <HelpIcon />
                  </Box>
                </Typography>
              </Typography>
            </Note>

            <Grid
              container
              item
              xs={12}
              spacing={2}
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12} md={4}>
                <InputFilterStyle>
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="lastname"
                    width={110}
                  >
                    Name
                  </Typography>
                  <DRxSelectStyle>
                    <YSSelectSearch
                      id="name"
                      options={
                        AjaxData.map((item: any, index: any) => ({
                          value: item.pharmacyName,
                          label: item.pharmacyName,
                        })) ?? [{ value: "", label: "" }]
                      }
                      name="Name"
                      value={formProps.values.Name}
                      onInputChange={(option: any, e: any) => {
                        formProps.setFieldValue("Name", e);
                        let Data = {
                          pharmacyName: e,
                        };
                        if (e.length >= 4) {
                          GetPharmacySearchAjaxCall(Data);
                        }
                      }}
                      error={
                        formProps.touched.Name && Boolean(formProps.errors.Name)
                      }
                    />
                  </DRxSelectStyle>
                </InputFilterStyle>
              </Grid>
              <Grid item xs={12} md={4}>
                <InputFilterStyle>
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="lastname"
                    width={110}
                  >
                    Type
                  </Typography>
                  <DRxSelectStyle>
                    <DRxSelect2
                      id="type"
                      name="Type"
                      label={"Type"}
                      options={[
                        { value: "0", label: " " },
                        { value: "All", label: "All" },
                        { value: "Mail Order", label: "Mail Order" },
                        { value: "Retail", label: "Retail" },
                        { value: "In-House", label: "In-House" },
                        { value: "FaxOnly", label: "Fax Only" },
                      ]}
                      onChange={(e: any) => {
                        checkValidation(e.target.value, formProps);
                      }}
                      value={formProps.values.Type}
                    />
                  </DRxSelectStyle>
                </InputFilterStyle>
              </Grid>
              <Grid item xs={12} md={4}>
                <InputFilterStyle>
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="lastname"
                    width={110}
                  >
                    City
                  </Typography>
                  <DRxInputStyle>
                    <DRxInput
                      id="city"
                      name="City"
                      className=""
                      label={"City"}
                    />
                  </DRxInputStyle>
                </InputFilterStyle>
              </Grid>
              <Grid item xs={12} md={4}>
                <InputFilterStyle>
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="lastname"
                    width={110}
                  >
                    Zip
                  </Typography>
                  <DRxInputStyle>
                    <DRxInput id="zip" name="Zip" className="" label={"Zip"} />
                  </DRxInputStyle>
                </InputFilterStyle>
              </Grid>
              <Grid item xs={12} md={4}>
                <InputFilterStyle>
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="lastname"
                    width={110}
                  >
                    State
                    {(mandateValidation || formProps.values.Type === "All") && (
                      // ||
                      // formProps.values.Type === ""
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      >
                        *
                      </Typography>
                    )}
                  </Typography>
                  <DRxSelectStyle>
                    <YSSelectSearch
                      id="state"
                      options={
                        AllDropdownsState?.statesOptions ?? [
                          { label: "", value: "" },
                        ]
                      }
                      isOptionEqualToValue={(option: any, value: any) =>
                        option.label === value
                      }
                      name="StateName"
                      value={formProps.values.StateName}
                      onChange={(event: any, value: any) => {
                        formProps.setFieldValue("State", value.value);
                        setStateValue(value.value);
                      }}
                      onInputChange={(option: any, e: any) => {
                        formProps.setFieldValue("StateName", e);
                        if (e === "") {
                          formProps.setFieldValue("State", "");
                        }
                      }}
                      error={
                        formProps.touched.StateName &&
                        Boolean(formProps.errors.StateName)
                      }
                    />
                  </DRxSelectStyle>
                </InputFilterStyle>
              </Grid>
              <Grid item xs={12} md={4}>
                <InputFilterStyle>
                  <Typography
                    component="label"
                    color={greyColor}
                    variant="body2"
                    htmlFor="lastname"
                    width={110}
                    marginRight={2}
                  >
                    Telephone
                  </Typography>
                  <Box>
                    <TelephoneStyle>
                      <DRxInputStyle>
                        <DRxInput
                          id="telephone"
                          name="TelephoneCode"
                          className=""
                          type="number"
                          label={"Telephone"}
                          onChange={(event: any) => {
                            formProps.setFieldValue(
                              "TelephoneCode",
                              event.target.value.slice(0, 3)
                            );
                            if (event.target.value.length === 3) {
                              phone2Ref?.current?.focus();
                            }
                          }}
                        />
                      </DRxInputStyle>
                      <DRxInputStyle>
                        <DRxInput
                          id="telephone"
                          name="Telephone1"
                          type="number"
                          className=""
                          inputRef={phone2Ref}
                          label={"Telephone"}
                          onChange={(event: any) => {
                            formProps.setFieldValue(
                              "Telephone1",
                              event.target.value.slice(0, 3)
                            );
                            if (event.target.value.length === 3) {
                              phone3Ref?.current?.focus();
                            }
                          }}
                        />
                      </DRxInputStyle>
                      <DRxInputStyle>
                        <DRxInput
                          id="telephone"
                          name="Telephone2"
                          type="number"
                          className=""
                          inputRef={phone3Ref}
                          label={"Telephone"}
                          onChange={(event: any) => {
                            formProps.setFieldValue(
                              "Telephone2",
                              event.target.value.slice(0, 4)
                            );
                          }}
                        />
                      </DRxInputStyle>
                    </TelephoneStyle>
                  </Box>
                </InputFilterStyle>
              </Grid>
              <Grid item xs={12}>
                <BtnGroupWAStyle style={{ textAlign: "right" }}>
                  {/* {props.pharmacyInfoState ? (
                    <YSButton
                      onClick={() => {
                        AddNewPharmacy();
                      }}
                      className=""
                      children={"Add to New Pharmacy"}
                      size={"medium"}
                      type="button"
                      color="primary"
                      variant="contained"
                    />
                  ) : (
                    <YSButton
                      onClick={() => {
                        AddToYourFavPharmacy();
                      }}
                      className=""
                      children={"Add to Favorite Pharmacy List"}
                      size={"medium"}
                      type="button"
                      color="primary"
                      variant="contained"
                    />
                  )} */}

                  <YSButton
                    size="medium"
                    className=""
                    color="secondary"
                    disabled={false}
                    type="reset"
                    children={"Reset"}
                    variant="outlined"
                  />
                  <YSButton
                    className=""
                    children={"Search"}
                    type="submit"
                    dataTestId="submitBtn"
                    color="primary"
                    variant="contained"
                    size="medium"
                  />
                </BtnGroupWAStyle>
              </Grid>
              <Grid marginTop={1} marginLeft={2} xs={12}>
                <Note>
                  <Typography variant="body2" component="div" fontWeight={600}>
                    Mail Order Pharmacies are listed irrespective of
                    Geographical Search
                  </Typography>
                </Note>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  textAlign={"right"}
                  variant="caption"
                  component="div"
                >
                  <Typography fontWeight={"bold"} variant="body2">
                    *TYPE:{" "}
                    <Typography fontWeight={600} variant="caption">
                      MO - Mail Order, RT - Retail, IH - In House, FO - Fax
                      Only, LTC - Long Term Care,{" "}
                      <>
                        <HtmlTooltip
                          placement="top"
                          arrow
                          title={
                            "This pharmacy supports electronic prescription transmission."
                          }
                        >
                          <IconButton className="">
                            <img
                              src={ErxSuccess}
                              alt="erx-success"
                              loading="lazy"
                              height={24}
                            />
                          </IconButton>
                        </HtmlTooltip>
                        ,
                      </>
                      <>
                        <HtmlTooltip
                          placement="top"
                          arrow
                          title={
                            "Electronic transmission of prescriptions containing Controlled drugs is not supported by this pharmacy."
                          }
                        >
                          <IconButton className="">
                            <img
                              src={ErxWarning}
                              alt="erx-warning"
                              loading="lazy"
                              height={24}
                            />
                          </IconButton>
                        </HtmlTooltip>
                        ,
                      </>
                      <>
                        <HtmlTooltip
                          placement="top"
                          arrow
                          title={
                            "Electronic transmission of prescriptions is disabled for this pharmacy."
                          }
                        >
                          <IconButton className="">
                            <img
                              src={ErxError}
                              alt="erx-error"
                              loading="lazy"
                              height={24}
                            />
                          </IconButton>
                        </HtmlTooltip>
                      </>
                    </Typography>
                  </Typography>{" "}
                </Typography>

                <DataGridListStyle className="stableMinHeight">
                  <DataGrid
                    columns={pharmacyColumns}
                    rowHeight={40}
                    headerHeight={36}
                    disableSelectionOnClick
                    rows={searchData?.items ?? []}
                    sortingOrder={["desc", "asc"]}
                    autoHeight
                    getRowHeight={() => "auto"}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10]}
                    paginationMode="server"
                    components={{
                      NoRowsOverlay: NoRecords,
                      NoResultsOverlay: NoRecords,
                      ErrorOverlay: ErrorOverlay,
                    }}
                    error={isError || undefined}
                    getRowId={(row) => row.pharmacyId ?? uuid()}
                    loading={isLoading}
                    page={page}
                    onPageChange={(newPage) => {
                      setPage(newPage);
                      getPharmacySearchDetails(newPage, data);
                    }}
                    rowCount={rowCountState}
                    // checkboxSelection
                    // onSelectionModelChange={(ids: any) => {
                    //   setSelectionData(ids);
                    // }}
                  />
                </DataGridListStyle>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
      <YSSnackBar
        message={addFavPharmacyState.message}
        variant={addFavPharmacyState.variant}
        open={addFavPharmacyState.open}
        handleClose={() => {
          setAddFavPharmacyState((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />

      <YSSnackBar
        message={addNewPharmacy.message}
        variant={addNewPharmacy.variant}
        open={addNewPharmacy.open}
        handleClose={() => {
          setAddNewPharmacy((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />

      <YSSnackBar
        message={pharmacySearchStatus.message}
        variant={pharmacySearchStatus.variant}
        open={pharmacySearchStatus.open}
        handleClose={() => {
          setPharmacySearchStatus((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
      <DialogPopup
        windowsize={"lg"}
        show={pharmacySearchHelpPopup}
        handleShowPopupClick={handleShowPharmacySearchHelpPopupClick}
        handleHidePopupClick={handleHidePharmacySearchHelpPopupClick}
        title={"Pharmacy Search Help Guide"}
      >
        <Grid
          container
          item
          xs={12}
          spacing={3}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} textAlign={"center"}>
            <Typography
              variant="h5"
              component={"h5"}
              color={"primary"}
              textAlign={"center"}
            >
              NEW PHARMACY SEARCH WORKFLOW
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              component={"p"}
              marginBottom={2}
              fontWeight={600}
            >
              Pharmacy selection workflow
            </Typography>
            <Typography variant="body2" component={"p"}>
              The pharmacy field is mandatory (if sending the prescription to
              the pharmacy) and the user has the flexibility of searching a
              pharmacy preferred by the patient. Click on the ' search pharmacy
              ' button in Rx Pad to go to the pharmacy selection process as
              shown below.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" component={"h6"}>
              Screenshot 1. To search pharmacy
            </Typography>
            <img
              src={ss1}
              style={{ maxWidth: "100%" }}
              alt="ss1"
              loading="lazy"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" component={"h6"}>
              Screenshot 2. To select drop down of state and search pharmacy
              according state and Pharmacy Type
            </Typography>
            <Typography variant="body2" component={"p"} marginBottom={2}>
              The new pharmacy search screen is shown below. The user can get
              the list of pharmacies based on the type and geo-parameters
              entered. The user can select the pharmacy in a favorable location
              for the patient and continue with the process of sending the
              prescription to the pharmacy
            </Typography>
            <img
              src={ss2}
              style={{ maxWidth: "100%" }}
              alt="ss2"
              loading="lazy"
            />
          </Grid>
          <Grid item xs={12}>
            <img
              src={ss3}
              style={{ maxWidth: "100%" }}
              alt="ss3"
              loading="lazy"
            />
            <Typography variant="body2" component={"p"}>
              <Typography variant="body2" component={"span"} fontWeight={600}>
                Note:
              </Typography>
              The search criteria is such that for ' retail ', 'In-House' and '
              All ' options (selected from the drop down), the state field is
              mandatory whereas for the mail orders and fax only pharmacies,
              none of the fields are mandatory but if any parameter is entered,
              the results will be displayed accordingly.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" component={"h6"}>
              ScreenShot 4. Now you can able to see the pharmacy name and
              address under one column.
            </Typography>
            <img
              src={ss4}
              style={{ maxWidth: "100%" }}
              alt="ss4"
              loading="lazy"
            />
            <Typography variant="body2" component={"p"} marginBottom={2}>
              You can see the list of pharmacies in the given screenshots, and
              click on the action icon to add the pharmacy to your favorite
              pharmacies list.
            </Typography>
          </Grid>
        </Grid>
      </DialogPopup>
    </>
  );
}
